import { TFunction } from '@wix/yoshi-flow-editor';
import {
  LAST_CATEGORY_ID_FOR_MIGRATION,
  MIGRATION_CATEGORY_CHANGED_THRESHOLD_MS,
} from '../constants/migration';
import { toNumber } from 'lodash';

export const getCategoryTitleForOOI = (
  categoryId: string,
  index: number,
  categoryTitle: string,
  t: TFunction,
  createdDate?: Date | string | null,
  updatedDate?: Date | string | null,
): string => {
  // Prefer real user-facing title when present (avoids "General7" for real categories)
  const hasRealTitle =
    categoryTitle?.trim() && !categoryTitle.toLowerCase().startsWith('comp-');
  if (hasRealTitle) {
    return categoryTitle;
  }

  const categoryIdSuffix = categoryId.slice(-5);
  const isMigratingCategory =
    LAST_CATEGORY_ID_FOR_MIGRATION.includes(categoryIdSuffix);
  const isMigratedName = categoryTitle?.toLowerCase().startsWith('comp-');
  const isEmptyCategory = !categoryTitle || categoryTitle.trim() === '';
  const isTimeDifferenceLessThan3Hours =
    updatedDate != null &&
    createdDate != null &&
    Math.abs(+new Date(updatedDate) - +new Date(createdDate)) <=
      MIGRATION_CATEGORY_CHANGED_THRESHOLD_MS;

  if (
    isMigratingCategory &&
    (isMigratedName || isEmptyCategory || isTimeDifferenceLessThan3Hours)
  ) {
    return `${t('display.tab.categories.general')}${toNumber(index + 1)}`;
  }
  return categoryTitle || '';
};
